'use client';

export const CHAT_STEP_GAP = 1;
export const CHAT_STEP_MIN_HEIGHT = '22px';
export const CHAT_BODY_FONT_SIZE_PX = 13;
export const CHAT_BODY_FONT_SIZE_PX_TORCH = 13;
export const CHAT_STEP_LABEL_SIZE = `${CHAT_BODY_FONT_SIZE_PX}px`;
export const CHAT_STEP_LABEL_COLOR = 'fg.subtle' as const;
export const CHAT_STEP_BODY_FONT_SIZE_PX = CHAT_BODY_FONT_SIZE_PX;
export const CHAT_STEP_BODY_FONT_SIZE_PX_TORCH = CHAT_BODY_FONT_SIZE_PX_TORCH;
export const CHAT_STEP_SUMMARY_COLOR = {
  _light: 'neutral.light.9',
  _dark: 'neutral.dark.8',
} as const;
